import { useMutation, useQueryClient } from 'react-query'
import { Button } from '../../../components/Button'
import { api } from '../../../services/api'
import { useToast } from '@chakra-ui/react'

async function onEnviarAprovacao({ numeroNota }) {
  const response = await api.get(`${process.env.REACT_APP_BASE_URL}/site/v2/liberacao-pedido/enviar-liberacao-pedido/${numeroNota}`)

  return response.data
}

export function EnviarLiberacao({ nunota, isShow }) {
  const toast = useToast({
    position: 'top-right',
    duration: 3000,
    isClosable: true,
  })

  const queryClient = useQueryClient()

  const { mutateAsync, isLoading } = useMutation({
    mutationFn: onEnviarAprovacao,
    onSuccess: (data) => {
      queryClient.invalidateQueries(['infoPedido', { numeroNota: nunota }])

      window.open(`${process.env.REACT_APP_BASE_URL}/site/v2/liberacao-pedido/enviar-liberacao-pedido/${nunota}`)
    },
    onError: (error) => {
      window.open(`${process.env.REACT_APP_BASE_URL}/site/v2/liberacao-pedido/enviar-liberacao-pedido/${nunota}`)
    },
  })

  async function handleEnviarAprovacao({ numeroNota }) {
    try {
      await mutateAsync({ numeroNota })
    } catch (error) {
      console.error(error)
    }
  }

  if (!isShow) {
    return null
  }

  return (
    <Button mx="auto" onClick={() => handleEnviarAprovacao({ numeroNota: nunota })} isLoading={isLoading} loadingText="Enviando...">
      {isShow ? 'Pedido liberado' : 'Enviar para Liberação'}
    </Button>
  )
}
